<template>
  <main>
    <div class="review-top">
      <h2 class="review-add-title">レビュー内容</h2>
      <p class="review-add-sentence"><span>{{nameUser}}</span> という公開名が、投稿者としてサービス上に表示されます。</p>
    </div>
    <app-loading v-if="isLoading"></app-loading>
    <section class="review-add" v-else>
      <div class="review-add__inner">
        <div class="review-main">
          <div class="review-main__thumb">
            <img :src="bookDetail.img_url" alt="">
          </div>
          <div class="review-main__body">
            <h3 class="review-main__ttl">{{bookDetail.name_book}}</h3>
            <div class="submit-stars">
              <span v-for="(star, index) in 5">
                <i class="fas fa-star full-star" v-if="index < filledStar" @click="fillStar(index)"></i>
                <i class="far fa-star" v-else @click="fillStar(index)"></i>
              </span>
            </div>
          </div>
        </div>
        <div>
          <textarea class="review-add__text" placeholder="ここに商品のレビューを記入（必須）" v-model="reviewText"></textarea>
        </div>
      </div>
    </section>
    <div class="review-submit">
      <a href="javascript:void(0);" class="btn review-submit__btn" @click="submitReview">投稿する</a>
    </div>
  </main>
</template>

<script>
  import Star from '../smallParts/Star.vue';
  import Loading from '../common/Loading.vue';

  export default {
    title: 'レビュー投稿 - abceed',
    headerTitle: 'レビュー投稿',
    description: '',
    keywords: '',
    headerType: 'historyBack',
    components: {
      appStar: Star,
      appLoading: Loading
    },
    data() {
      return {
        bookDetail: {},
        filledStar: 0,
        reviewText: ""
      }
    },
    beforeCreate() {
      this.$store.dispatch("changeLoadingCondition", true);
    },
    created() {
      this.$http.get('webstore/book/detail?id_book=' + this.$route.params.id)
        .then(res => {
          return res.json();
        }, err => {
          return err.json();
        }).then(data => {
          this.bookDetail = data.detail;
          if (data.detail.your_review) {
            this.filledStar = data.detail.your_review.rating;
            this.reviewText = data.detail.your_review.message;
          }
          this.$store.dispatch("changeLoadingCondition", false);
        }).catch(() => {
          this.$store.dispatch("changeLoadingCondition", false);
        });
      this.$store.dispatch("changeHeaderType", "review");
    },
    destroyed() {
      this.$store.dispatch("changeHeaderType", "default");
    },
    computed: {
      nameUser() {
        return window.localStorage.getItem(['userName']);
      },
      isLoading() {
        return this.$store.getters.isLoading;
      }
    },
    methods: {
      fillStar(number) {
        this.filledStar = number + 1;
      },
      submitReview() {
        if (this.filledStar <= 0) {
          alert("レビュー評価(星)を選択してください");
          return;
        }
        if (this.reviewText === "") {
          alert("レビューを記載してください");
          return;
        }
        this.$store.dispatch("changeLoadingCondition", true);
        const order = {
          id_book: this.$route.params.id,
          rating: this.filledStar,
          message: this.reviewText
        };
        this.$store.dispatch("addReview", order)
          .then(() => {
            this.$store.dispatch("changeLoadingCondition", false);
            this.$router.push({ name: 'bookReview' });
          })
          .catch(() => {
            alert("レビューの投稿に失敗しました。");
            this.$store.dispatch("changeLoadingCondition", false);
          });
      }
    }
  }
</script>

<style scoped lang="scss">
  .review-top {
    max-width: 440px;
    margin: 0 auto;
    padding: 15px 15px 10px;
    text-align: left;
  }
  .review-add-title {
    font-size: 15px;
    font-size: 1.5rem;
    font-weight: bold;
  }
  .review-add-sentence {
    color: #979595;
    font-size: 13px;
    font-size: 1.3rem;
    span {
      color: red;
      margin-right: 5px;
    }
  }
  .review-add {
    background-color: #fff;
    padding: 10px 5px 5px;
    &__inner {
      max-width: 440px;
      margin: 0 auto;
    }
    &__text {
      width: 100%;
      height: 120px;
      border-radius: 2px;
      padding: 8px;
      font-size: 14px;
      font-size: 1.4rem;
      border: 1px solid #979595;
    }
  }
  .review-main {
    display: flex;
    padding: 0 10px 10px;
    &__thumb {
      width: 56px;
      margin-right: 15px;
      img {
        width: 100%;
        height: auto;
      }
    }
    &__ttl {
      font-weight: bold;
      font-size: 15px;
      font-size: 1.5rem;
      text-align: left;
    }
    &__body {
      width: calc(100% - 71px);
    }
  }
  .submit-stars {
    color: #b6b6b6;
    font-size: 28px;
    font-size: 2.8rem;
    text-align: left;
    span {
      margin-right: 6px;
    }
    .full-star {
      color: #ffc968;
    }
  }
  .review-submit {
    padding: 40px 0 15px;
    &__btn {
      margin: 0 auto;
      width: 100%;
      max-width: 320px;
      height: 44px;
      line-height: 44px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/books/BookReviewAdd.vue